import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {ROLE_ENDPOINTS} from "../../services/network/endpoints";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {fetchSubUsersBySector} from "../../services/network/sub_user-api";

export function useFetchSubUsersBySector(sectorID:string) {
    const {data, error, isLoading} = useQuery({
        queryKey: ["/subUsersSector", sectorID],
        queryFn: () => fetchSubUsersBySector(sectorID),
        enabled: Boolean(sectorID),
    });

    return {
        subUsersSectorData: data?.data,
        subUsersSectorError: error,
        subUsersSectorIsLoading: isLoading,
    };
}
